/**
 * @file HOC for redirecting to album folder view if there are no
 * selected albums on discover mode.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'lodash.flowright';
import { withRouter, Redirect } from 'react-router-dom';

import { hasSelectedAlbums } from '../../../util/discover-album-folder';

const WithRequireSelectedAlbums = WrappedComponent =>
  class extends Component {
    static propTypes = {
      identities: PropTypes.arrayOf(
        PropTypes.shape({
          selectedAlbums: PropTypes.arrayOf(PropTypes.object).isRequired,
        }),
      ).isRequired,
      match: PropTypes.shape({
        params: PropTypes.shape({
          albumFolderId: PropTypes.string.isRequired,
        }),
      }),
    };

    render() {
      const { identities, match } = this.props;

      return !hasSelectedAlbums(identities) ? (
        <Redirect
          to={`/discover/album-folder/${match.params.albumFolderId}/faces`}
        />
      ) : (
        <WrappedComponent {...this.props} />
      );
    }
  };

const mapStateToProps = ({ discoverAlbumFolder }) => ({
  identities: discoverAlbumFolder.identities,
});

export { WithRequireSelectedAlbums };

export default WrappedComponent => {
  return compose(
    withRouter,
    connect(mapStateToProps),
    WithRequireSelectedAlbums,
  )(WrappedComponent);
};
